import React from "react"

interface LiveDataControlsProps {
	isLiveMode: boolean
	liveUpdateInterval: number
	customInterval: number
	macAddresses: string[]
	onToggleLiveMode: () => void
	onIntervalChange: (interval: number) => void
}

const LiveDataControls: React.FC<LiveDataControlsProps> = ({
	isLiveMode,
	liveUpdateInterval,
	customInterval,
	macAddresses,
	onToggleLiveMode,
	onIntervalChange,
}) => {
	return (
		<div className="bg-white dark:bg-gray-800 p-4 rounded-lg border border-gray-200 dark:border-gray-700 mb-6">
			<h2 className="font-semibold mb-3 text-gray-900 dark:text-white">Live Data Controls</h2>
			<div className="flex gap-4 items-center flex-wrap">
				<button
					onClick={onToggleLiveMode}
					disabled={macAddresses.length === 0}
					className={`px-4 py-2 rounded font-medium ${
						isLiveMode
							? "bg-red-500 hover:bg-red-600 text-white"
							: "bg-green-500 hover:bg-green-600 text-white"
					} disabled:bg-gray-300 dark:disabled:bg-gray-600 disabled:cursor-not-allowed`}>
					{isLiveMode ? "Stop Live Updates" : "Start Live Updates"}
				</button>

				<div className="flex items-center gap-2">
					<label className="text-sm text-gray-600 dark:text-gray-400">Update interval:</label>
					<select
						value={customInterval}
						onChange={(e) => onIntervalChange(Number(e.target.value))}
						className="px-3 py-1 border border-gray-300 dark:border-gray-600 rounded text-sm bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-indigo-500 dark:focus:ring-indigo-400"
						disabled={isLiveMode}>
						<option value={1}>1 second</option>
						<option value={2}>2 seconds</option>
						<option value={5}>5 seconds</option>
						<option value={10}>10 seconds</option>
						<option value={30}>30 seconds</option>
						<option value={60}>1 minute</option>
					</select>
				</div>

				{isLiveMode && (
					<div className="text-sm text-gray-600 dark:text-gray-400">
						Next update in ~{liveUpdateInterval} seconds
					</div>
				)}
			</div>
		</div>
	)
}

export default LiveDataControls
